var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-center",domProps:{"textContent":_vm._s(_vm.titleContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }